import { POST_BUSINESS_PROFILE } from "../configs/routes.js";
import api from "./api.js";

const postBusinessProfile = (businessData = {}) =>
  new Promise((resolve, reject) => {
    api
      .post(POST_BUSINESS_PROFILE, businessData)
      .then((response) => resolve(response.data))
      .catch((err) => reject(err.message));
  });

export default postBusinessProfile;
